import { MessageFactory } from "@routes/Article/components/ArticleSubshare/helpers";
import { LambdaResponsePayload } from "@routes/Article/types/Alacrity";

export type MessagesProps = LambdaResponsePayload;

export default function Messages({
  data: { responseType, giftCount },
}: MessagesProps): React.ReactElement {
  const Message = MessageFactory(responseType);

  return <>{Message ? <Message {...{ giftCount }} /> : null}</>;
}
